import CallModal from "./CallModal/index";

export default CallModal;
